<template>
    <div>
      <h3 class="text-primary">Add Payment</h3>
      <form @submit.prevent="addPayment">
        <div class="mb-3">
          <label for="amount" class="form-label">Amount</label>
          <input
            type="number"
            v-model="payment.amount"
            id="amount"
            class="form-control"
            placeholder="Enter payment amount"
            required
          />
        </div>
  
        <div class="mb-3">
          <label for="status" class="form-label">Payment Status</label>
          <select v-model="payment.status" id="status" class="form-select" required>
            <option value="" disabled>Select status</option>
            <option value="1">Paid</option>
            <option value="0">Pending</option>
            <option value="-1">Failed</option>
          </select>
        </div>
  
        <div class="mb-3">
          <label for="date" class="form-label">Payment Date</label>
          <input
            type="date"
            v-model="payment.date"
            id="date"
            class="form-control"
            required
          />
        </div>
  
        <button type="submit" class="btn btn-primary w-100">Submit Payment</button>
      </form>
  
      <hr />
  
      <h3 class="text-secondary">Payment History</h3>
      <ul class="list-group">
        <li v-for="record in paymentHistory" :key="record.id" class="list-group-item">
          <strong>Amount:</strong> {{ record.amount }} |
          <strong>Status:</strong> {{ getStatusLabel(record.status) }} |
          <strong>Date:</strong> {{ record.date }}
        </li>
      </ul>
    </div>
  </template>

<script>
import axios from 'axios';

export default {
  name: "StudentPayment",
  props: {
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      payment: {
        amount: null,
        status: "",
        date: "",
      },
      paymentHistory: [],
    };
  },
  methods: {
    async fetchPaymentHistory() {
      // Fetch payment history for the student from backend
      try {
        const response = await axios.get(`/getPaymentHistory/${this.studentId}`);
        this.paymentHistory = response.data;
      } catch (error) {
        console.error("Error fetching payment history:", error);
      }
    },
    async addPayment() {
  try {
    const response = await axios.post("/addpayments", {
      student_id: this.studentId,
      amount: this.payment.amount,
      status: this.payment.status,
      date: this.payment.date,
    });

    console.log("Payment response:", response.data); // Use the response for debugging or further logic

    // Reset form
    this.payment = { amount: null, status: "", date: "" };

    // Refresh payment history
    this.fetchPaymentHistory();

    // Notify parent component
    this.$emit("payment-updated");

    alert("Payment added successfully!");
  } catch (error) {
    console.error("Error adding payment:", error);
  }
},
    getStatusLabel(status) {
      switch (status) {
        case 1:
          return "Paid";
        case 0:
          return "Pending";
        case -1:
          return "Failed";
        default:
          return "Unknown";
      }
    },
  },
  mounted() {
    this.fetchPaymentHistory();
  },
};
</script>

<style lang="scss" scoped>

ul {
  padding: 0;
  list-style: none;
}
.list-group-item {
  margin-bottom: 5px;
}

</style>